export default {"src":"/_next/static/media/hungerhub-exclusive.04f669d4.svg","height":15,"width":13};